import {
  AncillariesInt,
  AncillaryInt,
  BagAncillarieInt,
  BagBenefitItem,
  BagPassangerInt,
  BagStackInt,
  Benefit,
  BookedSegmentChoiceCollection,
  BookedTravelerInt,
  BookingClasses,
  FreeBaggageAllowance,
  FreeBaggageAllowancePerLegsArray,
  PaxInfoInt,
  SeatBenefit,
  SeatPassanger,
  TierBenefit,
  ResidenceInfo,
  BenefitInt,
  Eligibilities
} from "@interfaces/*";
import { TypeBagsWeight, BagsWeightCode, BagsWeightForWeight, GROUP_CODE, PAX_TYPE, SeatPassangerEstatus, StatusBag, WeightUnit, ESTATUS_CHECKIN } from "@app/enums";
import { getUniqueId } from "@app/utils";
import { InternationFlow } from "./internationFlow.model";

export class Passenger {
  public allTicketNumbers: string[] = [];
  public checkinStatus: boolean = false;
  public checkinStatusBySegment;
  public countryOfResidence: string;
  public dateOfBirth: string;
  public destinationAddress: string;
  public etaAlreadySent;
  public firstName: string;
  public gender: string;
  public id: string;
  public lastName: string;
  public nameRefNumber: string
  public onwardTravelDate;
  public paxType: PAX_TYPE;
  public returningDateAlreadySent;
  public segmentChoices: any;
  public ticketNumber;
  public ticketNumbers;
  public timaticInfo: any;
  public timaticProvided;
  public travelDocument: any;
  public visaInfo: any;
  public visaInfoAlreadySent;
  public isUSPerson: boolean = false;
  public ancillaries: AncillariesInt;
  public paidAncillaries: AncillaryInt[];
  public bookingClasses: any;
  public isCorporateFrequentFlyer: boolean;
  public frequentFlyerNumber: string;
  public frequentFlyerProgram: string;
  public frequentFlyerProgramDisplayName: string;
  public declinedEmergencyContact: boolean = false
  public displayName: string;
  public email: string;
  public emergencyContact: string;
  public ineligibleReasons: string[];
  public isEligibleToCheckin: boolean;
  public isOverBookingOfferAccepted: boolean;
  public isOverBookingEligible: boolean;
  public isSelectedToCheckin: boolean;
  public isSkyPriority: boolean;
  public ktn: string;
  public loyalty: any;
  public missingCheckinRequiredFields: string[];
  public paxInfo?: PaxInfoInt;
  public phones: any;
  public redressNumber: string;
  public savedEmails: string[];
  public ssrRemarks: any;
  public internationFlow: InternationFlow
  public hasInfant: boolean;
  public residenceInfo: ResidenceInfo
  public classificationPaxType: string;
  public passengerType: string;
  public checkinSelected: boolean;
  public showAdditionalInfo: boolean;
  public corporateFrequentFlyerNumber: string;
  public cabinClass: string;
  public ssrCodes: string[];

  public freeCheckedBagAllowance: number = 0;
  public freeCheckedBagAllowanceMaxWeight: number;
  public freeCheckedBagAllowanceWeightUnit: string;
  public freeCheckedBagAllowanceLabel: string;
  public freeCheckedBagAllowenceExtraWeight: any;
  public freeCarryOnBagAllowance: number = 0;
  public freeCarryOnBagAllowanceUnits: any;
  public isCarryOnDroppedOff: boolean;

  public bagsMaxAllowableWeight: number;
  public bagsOverweightUnitCharge: number;
  public numPaidBags: number;
  public numRedeemedBags: number;
  public numRedeemedUsedBags: number;
  public numRedeemedAndUsedBags: number;
  public numPaidCarryOnBags: number;
  public numPaidBags20K: number;
  public numCheckedInBags: number;
  public numCheckedInBags20: number;
  public numCarryOnBags: number;
  public totalDue: number;
  public numBagsDroppedOff: number;
  public numBagsDroppedOff20KG: number;
  public numCheckedInBagsPremier: number;
  public totalseatscurrency: number
  public paidBags = 0;
  public paidBagsAndUsed = 0;
  public reedemBagsAndUSed = 0;
  public codeBags20 = []
  public carryOnChecked: number;
  public checkedBags: number = 0;
  public checkedBags20KG: number = 0;
  public reedemBags = 0;
  public freeBaggageAllowancePerLegsArray;
  public freeBaggageAllowance;
  public benefit: any;
  public totalBags = 0;
  public bagStack: Array<BagPassangerInt> = [];
  public bagStackCarryon: Array<BagPassangerInt> = [];
  public bagsBenefit: Array<BagBenefitItem> = [];
  public seatBenefit: SeatBenefit;
  public prePaidSeat: boolean;
  public apiSeats: Array<SeatPassanger> = [];
  public apiSeatsPaids: Array<SeatPassanger> = [];
  public seats: Array<SeatPassanger> = [];
  public seatsOld: Array<SeatPassanger> = [];
  public passengerNameNumber: string;
  public eligibilities: Eligibilities;
  public ffTierLevel: string;

  constructor(passenger?: BookedTravelerInt) {
    if (passenger) {
      this.allTicketNumbers = passenger.allTicketNumbers;
      this.checkinStatus = passenger.checkinStatus;
      this.paxType = passenger.paxType;
      this.isUSPerson = passenger.isUSPerson
      this.countryOfResidence = passenger.countryOfResidence;
      this.dateOfBirth = passenger.dateOfBirth;
      this.destinationAddress = passenger.destinationAddress;
      this.firstName = passenger.firstName;
      this.lastName = passenger.lastName;
      this.gender = passenger.gender;
      this.id = passenger.id;
      this.nameRefNumber = passenger.nameRefNumber;
      this.segmentChoices = passenger.segmentChoices;
      this.timaticInfo = passenger.timaticInfo;
      this.travelDocument = passenger.travelDocument;
      this.visaInfo = passenger.visaInfo;

      this.classificationPaxType = passenger.classificationPaxType;
      this.passengerType = passenger.passengerType;
      this.checkinSelected = false;
      this.showAdditionalInfo = true;

      this.ancillaries = passenger.ancillaries;
      this.bookingClasses = passenger.bookingClasses;
      this.paxInfo = passenger?.paxInfo || {};
      this.frequentFlyerNumber = passenger.frequentFlyerNumber ?? passenger.corporateFrequentFlyerNumber;
      this.corporateFrequentFlyerNumber = passenger.corporateFrequentFlyerNumber;
      this.frequentFlyerProgram = passenger.frequentFlyerProgram ?? passenger.corporateFrequentFlyerProgram;
      this.isCorporateFrequentFlyer = passenger.corporateFrequentFlyerNumber && passenger.corporateFrequentFlyerProgram;
      this.declinedEmergencyContact = passenger.declinedEmergencyContact
      this.displayName = passenger.displayName;
      this.email = passenger.email;

      this.ineligibleReasons = passenger.ineligibleReasons;

      this.isEligibleToCheckin = passenger.isEligibleToCheckin;
      this.isOverBookingEligible = passenger.isOverBookingEligible;
      this.isOverBookingOfferAccepted = passenger.overBookingInfo?.accepted ? passenger.overBookingInfo.accepted : false;
      this.isSelectedToCheckin = passenger.isSelectedToCheckin;
      this.isSkyPriority = passenger.isSkyPriority;
      this.ktn = passenger.ktn;
      this.loyalty = passenger.loyalty;
      this.missingCheckinRequiredFields = passenger.missingCheckinRequiredFields;
      this.phones = passenger.phones;
      this.redressNumber = passenger.redressNumber;
      this.savedEmails = passenger.savedEmails;
      this.ssrRemarks = passenger.ssrRemarks;
      this.ssrCodes = passenger.ssrRemarks?.ssrCodes || [];

      this.benefit = passenger.benefit;
      this.freeBaggageAllowancePerLegsArray = passenger.freeBaggageAllowancePerLegsArray;
      this.freeBaggageAllowance = passenger.freeBaggageAllowance;
      this.checkedBags = passenger.checkedBags;
      this.checkedBags20KG = passenger.checkedBags20KG;
      this.carryOnChecked = passenger.carryOnChecked ? 1 : 0;
      this.isCarryOnDroppedOff = passenger.carryOnChecked
      if (this.paxType == PAX_TYPE.ADULT || this.paxType == PAX_TYPE.CHILD) {
        this.getStackBags();
        this.getSeatBenifit(passenger.benefit);
        this.getSeatPassanger(passenger.segmentChoices)
        this.getBookingClasse(passenger.bookingClasses);
        this.internationFlow = new InternationFlow(passenger.missingCheckinRequiredFields);
        this.hasInfant = passenger.infant ? true : false;
        this.ffTierLevel = this.getFFTierLevel();
      }
    }
  }

  get estatusCheckin() {
    let estatusCheckin: ESTATUS_CHECKIN;
    if (this.isEligibleToCheckin) {
      if (!this.checkinStatus && !this.isEligibleToCheckin) {
        estatusCheckin = ESTATUS_CHECKIN.NOT_DOCUMENTS;
      } else {
        estatusCheckin = this.checkinStatus ? ESTATUS_CHECKIN.HAS_CHEKIN : ESTATUS_CHECKIN.READY_FOR_CHECKIN
      }
    } else {
      estatusCheckin = ESTATUS_CHECKIN.NO_ELEGIBLE_TO_CHECKIN;
    }
    return estatusCheckin
  }

  getFFTierLevel() {
    /*let ffTierLevel: string = '';
    const benefit: TierBenefit = this.benefit?._collection[0];
    if (benefit){
      ffTierLevel = benefit.code;
    }*/
    const tierLeves = {
      'PLT': 'platinum',
      'TTN': 'titanium',
      'SLV': 'silver',
      'CLA': 'gold',
      'TTP': 'caballero aguila'
    }
    let ffTierLevel: string = ''
    if (this.loyalty?.length > 0) {
      ffTierLevel = this.loyalty[0].tierPriority
    }
    return tierLeves[ffTierLevel] || '';
  }

  private getStackBags() {
    this.bagsMaxAllowableWeight = 45;
    const includeBags = this.getBagsInclude(this.freeBaggageAllowancePerLegsArray, this.freeBaggageAllowance);
    const { bagsChecked, bagsCarryOn } = includeBags;

    bagsChecked.map((bag, i) => {
      this.bagStack.push({
        idBag: getUniqueId(4),
        commercialName: '',
        emdConsummedAtIssuance: '',
        legCode: bag.legCode,
        quantity: 1,
        used: i < this.checkedBags,
        groupCode: GROUP_CODE.BAGS,
        selected: i >= this.checkedBags,
        type: '',
        rficSubcode: '',
        typeBagWeight: bag.bagWeight,
        paid: false,
        statusBag: StatusBag.INCLUDE
      })
    });

    bagsCarryOn.map((bag, i) => {
      this.bagStackCarryon.push({
        idBag: getUniqueId(4),
        commercialName: '',
        emdConsummedAtIssuance: '',
        legCode: bag.legCode,
        quantity: 1,
        used: i < this.carryOnChecked,
        groupCode: GROUP_CODE.BAGS,
        selected: true,
        type: '',
        rficSubcode: '',
        typeBagWeight: bag.bagWeight,
        paid: false,
        statusBag: i < this.carryOnChecked ? StatusBag.DOCUMENT : StatusBag.INCLUDE
      })
    });

    const benefitBags = this.getStackBagsBenifit(this.benefit);
    benefitBags.map((bag, i) => {
      this.bagStack.push({
        idBag: getUniqueId(4),
        commercialName: '',
        emdConsummedAtIssuance: '',
        legCode: bag.legCode,
        quantity: 1,
        redeemed: true,
        used: (i + 1) < benefitBags.length,
        groupCode: GROUP_CODE.BAGS,
        selected: false,
        type: '08K',
        rficSubcode: '08K',
        typeBagWeight: bag.bagWeight,
        paid: false,
        statusBag: StatusBag.REDEEMED
      })
    });

    const excludedTypesAncillaries = ['07X', '0NS', '0D6', '0DC', '0DD', '0EE', '0FR', '0KG', '0KO', '0N8'];
    const ancillaries = this.ancillaries._collection?.filter(x => !excludedTypesAncillaries.includes(x.type) && x.groupCode == GROUP_CODE.BAGS);
    for (const acillary of ancillaries) {
      const bagWeight = BagsWeightCode["20KG"].includes(acillary.rficSubcode) ? TypeBagsWeight._20KG : (BagsWeightCode["25KG"].includes(acillary.rficSubcode) ? TypeBagsWeight._25KG : TypeBagsWeight._32KG)
      this.bagStack.push(
        {
          idBag: getUniqueId(4),
          ...acillary,
          selected: !acillary.used,
          typeBagWeight: bagWeight,
          paid: acillary.redeemed ? false : true,
          statusBag: acillary.redeemed ? StatusBag.REDEEMED_APPLIED : StatusBag.PAID,
        }
      )
    }
    // const carryonType = resevation.isNewBF? '0CZ': '07X'
    // const ancillariesCarryon = this.ancillaries?._collection.filter(x => x.type == carryonType && x.groupCode == GROUP_CODE.TRAVEL_SERVICES);
     const ancillariesCarryon = this.ancillaries._collection?.filter(x => x.type == '07X' && x.groupCode == GROUP_CODE.TRAVEL_SERVICES);
    for (const acillary of ancillariesCarryon) {
      const bagWeight = BagsWeightCode["15KG"].includes(acillary.rficSubcode) ? TypeBagsWeight._15KG : TypeBagsWeight._10KG;
      this.bagStackCarryon[0] =
      {
        idBag: getUniqueId(4),
        ...acillary,
        selected: !acillary.used,
        typeBagWeight: bagWeight,
        paid: true,
        statusBag: StatusBag.PAID,
        used: this.carryOnChecked == 1 ? true : false
      }

    }

  }

  private getBagsInclude(freeBaggagePerLegsArray: Array<FreeBaggageAllowancePerLegsArray>, freeBaggage: FreeBaggageAllowance): { bagsChecked: BagStackInt[], bagsCarryOn: BagStackInt[] } {
    let bagsChecked: BagStackInt[] = [];
    let bagsCarryOn: BagStackInt[] = [];

    if (freeBaggagePerLegsArray?.length > 0) {
      const [freeBaggagePer] = freeBaggagePerLegsArray
      const freeBaggageAllowance = freeBaggagePer.freeBaggageAllowance;
      const bagCheckedWeight = freeBaggageAllowance.checkedWeightCollection?.find(x => x.checkedWeightUnit == WeightUnit.KG)?.checkedFreeWeight;
      const bagCheckedWeightCarryon = freeBaggageAllowance.carryOnWeightCollection?.find(x => x.carryOnWeightUnit == WeightUnit.KG)?.carryOnWeight;
      for (let i = 0; i < freeBaggageAllowance.checked; i++) {
        const bagWeight = BagsWeightForWeight["20KG"].includes(`${bagCheckedWeight}`) ? TypeBagsWeight._20KG : (BagsWeightForWeight["25KG"].includes(`${bagCheckedWeight}`) ? TypeBagsWeight._25KG : TypeBagsWeight._32KG)
        const bag: BagStackInt = {
          legCode: freeBaggagePer.legCode,
          bagWeight
        }
        bagsChecked.push(bag);
      }

      for (let i = 0; i < freeBaggageAllowance.carryOn; i++) {
        const bagWeight = BagsWeightForWeight["10KG"].includes(`${bagCheckedWeightCarryon}`) ? TypeBagsWeight._10KG : TypeBagsWeight._15KG
        const bagCarryon: BagStackInt = {
          legCode: freeBaggagePer.legCode,
          bagWeight
        }
        bagsCarryOn.push(bagCarryon);
      }
    }

    if (freeBaggage.checked > 0 || freeBaggage.carryOn) {
      const exitsBagsInclude = bagsChecked.find(bag => bag.bagWeight == TypeBagsWeight._20KG
        || bag.bagWeight == TypeBagsWeight._25KG
        || bag.bagWeight == TypeBagsWeight._32KG)

      if (!exitsBagsInclude) {
        for (let index = 0; index < freeBaggage.checked; index++) {
          const bagWeight = TypeBagsWeight._25KG
          const bag: BagStackInt = {
            legCode: '',
            bagWeight
          }
          bagsChecked.push(bag);
        }
      }

      const exitsBagsIncludeCarryon = bagsCarryOn.find(bag => bag.bagWeight == TypeBagsWeight._10KG
        || bag.bagWeight == TypeBagsWeight._15KG)

      if (!exitsBagsIncludeCarryon) {
        for (let index = 0; index < freeBaggage.carryOn; index++) {
          const bagWeight = TypeBagsWeight._10KG
          const bag: BagStackInt = {
            legCode: '',
            bagWeight
          }
          bagsCarryOn.push(bag);
        }
      }
    }

    this.freeCarryOnBagAllowance = bagsChecked?.length;
    this.freeCheckedBagAllowance = bagsCarryOn?.length;

    return {
      bagsChecked,
      bagsCarryOn
    }
  }
  private getStackBagsBenifit(benefit: Benefit): BagStackInt[] {
    const benefitData: TierBenefit = benefit?._collection ? benefit._collection[0] : undefined
    let bagsCheckedBenefit: BagStackInt[] = [];

    if (benefitData) {
      this.bagsBenefit = [];
      const bagsCount = benefitData.bagBenefit?.freeBagAllowance?.checked;
      if (benefitData.bagBenefit && bagsCount > 0) {
        this.bagsBenefit.push({
          title: benefitData.bagBenefit.description,
          desc: 'freeBagBenefit_' + bagsCount,
          code: benefitData.bagBenefit.reason,
          count: bagsCount,
        });
        const { legCode } = benefitData.bagBenefit;
        const appliedBags = this.ancillaries._collection.filter(x => x.legCode == legCode && x.redeemed)?.length || 0;
        for (let i = 0; i < (bagsCount - appliedBags); i++) {
          const bag: BagStackInt = {
            legCode: legCode,
            bagWeight: TypeBagsWeight._25KG
          }
          bagsCheckedBenefit.push(bag);
        }
      }

      if (benefitData.bagBenefitCobrand && benefitData.bagBenefitCobrand.freeBagAllowanceByCardList) {
        for (var i = 0; i < benefitData.bagBenefitCobrand.freeBagAllowanceByCardList.length; i++) {
          var benefitCobrand = benefitData.bagBenefitCobrand.freeBagAllowanceByCardList[i];
          if (!benefitCobrand.checked) continue;
          this.bagsBenefit.push({
            title: benefitCobrand.description,
            desc: 'freeBagBenefit_' + benefitCobrand.checked,
            code: benefitCobrand.cobrandCode,
            count: benefitCobrand.checked,
          });
        }
      }
    } else {
      this.bagsBenefit = null;
    }
    this.reedemBags = benefitData?.bagBenefit?.freeBagAllowance?.checked || 0;
    return bagsCheckedBenefit
  }

  public get bags20Kg() {
    return this.bagStack.filter(x => x.typeBagWeight == TypeBagsWeight._20KG && !x.used)?.length || 0;
  }

  public get bags25Kg() {
    return this.bagStack.filter(x => x.typeBagWeight == TypeBagsWeight._25KG && x.statusBag != StatusBag.REDEEMED && !x.used)?.length || 0;
  }

  public get bags32Kg() {
    return this.bagStack.filter(x => x.typeBagWeight == TypeBagsWeight._32KG && !x.used)?.length || 0;
  }

  public get hasRedeemed() {
    return this.bagStack.find(x => x.statusBag == StatusBag.REDEEMED_APPLIED) ? true : false;
  }

  public get hasRedeeme() {
    return this.bagStack.find(x => x.statusBag == StatusBag.REDEEMED) ? true : false;
  }

  public bagsPrePaid(bagWeight: TypeBagsWeight) {
    return this.bagStack.filter(x => x.statusBag == StatusBag.PAID && x.typeBagWeight == bagWeight && !x.used);
  }

  public bagsNotUsed(bagWeight: TypeBagsWeight) {
    return this.bagStack.filter(x => x.typeBagWeight == bagWeight && !x.used);
  }

  public get bagsNotUsedTotal() {
    return this.bagStack.filter(x => !x.used && x.statusBag !== StatusBag.TO_PAY && x.statusBag != StatusBag.REDEEMED);
  }

  public get bagsUsed() {
    return this.bagStack.filter(x => x.used);
  }

  public onPlus20kg(count: number) {
    const bags = this.bagStack.filter(x => x.typeBagWeight == TypeBagsWeight._20KG && !x.used);

    bags.map((x, index) => { if (index < count) { x.selected = true } });

    if (count > bags.length) {
      this.addBagToPay(TypeBagsWeight._20KG);
    }
  }

  public onPlus25kg(count: number, extrasBags: BagAncillarieInt[], isDomestic: boolean) {
    const countBagsIncludeOthers = this.bagStack.filter(x => x.typeBagWeight != TypeBagsWeight._25KG && x.statusBag == StatusBag.INCLUDE)?.length || 0;
    const countBagsUsed = this.bagStack.filter(x => x.typeBagWeight == TypeBagsWeight._25KG && x.used)?.length || 0;
    const countBags20kg = this.bagStack.filter(x => x.typeBagWeight == TypeBagsWeight._20KG)?.length || 0;
    let bags = this.bagStack.filter(x => x.typeBagWeight == TypeBagsWeight._25KG && !x.used && x.statusBag != StatusBag.REDEEMED);
    bags.map((x, index) => { if (index < count) { x.selected = true } });
    if (count > bags.length) {
      let order = count + countBagsIncludeOthers + countBagsUsed + countBags20kg;
      if (this.hasInfant && !isDomestic) {
        order -= 1;
      }
      const extraBags = extrasBags.find(x => x.order == order)
      this.addBagToPay(TypeBagsWeight._25KG, extraBags);
    }
  }


  public onPlus32kg(count: number) {
    const bags = this.bagStack.filter(x => x.typeBagWeight == TypeBagsWeight._32KG && !x.used);
    bags.map((x, index) => { if (index < count) { x.selected = true } });
    if (count > bags.length) {
      this.addBagToPay(TypeBagsWeight._32KG);
    }
  }


  public onMinusBag(count: number, bagWeight: TypeBagsWeight) {
    const bags = this.bagStack.filter(x => x.typeBagWeight == bagWeight && !x.used && x.selected);
    if (count < bags.length) {
      let lastBag = bags.reverse()[0];
      if (lastBag.statusBag == StatusBag.TO_PAY) {
        this.bagStack = this.bagStack.filter(x => x.idBag != lastBag.idBag);
      } else {
        lastBag.selected = false;
      }
    }
  }


  public availableBagsAdd(bagWeight: TypeBagsWeight) {
    const totalBags = this.totalBags;

    if (bagWeight == TypeBagsWeight._20KG) {
      return this.bagStack.filter(x => x.typeBagWeight == TypeBagsWeight._20KG && !x.used && x.selected == false)?.length > 0;
    } else if (bagWeight == TypeBagsWeight._25KG) {
      const bags25Kg = this.bagStack.filter(x => x.typeBagWeight == TypeBagsWeight._25KG)?.length || 0;
      const bags20Kg = this.bagStack.filter(x => x.typeBagWeight == TypeBagsWeight._20KG)?.length || 0;
      const bagsRedeemed = this.bagStack.filter(x => x.typeBagWeight == bagWeight && x.statusBag == StatusBag.REDEEMED && !x.used)?.length || 0;
      const bagsInclude = this.bagStack.filter(x => x.typeBagWeight == bagWeight && x.statusBag == StatusBag.INCLUDE)?.length || 0;
      return (totalBags - (bags25Kg - bagsRedeemed - bagsInclude) - bags20Kg) > 0;
    } else if (bagWeight == TypeBagsWeight._32KG) {
      const totalBags32kgNotSelect = this.bagStack.filter(x => x.typeBagWeight == TypeBagsWeight._32KG && !x.used)?.length;
      const totalBags32kgSelect = this.bagStack.filter(x => x.typeBagWeight == TypeBagsWeight._32KG && !x.used && x.selected)?.length;
      return (totalBags32kgNotSelect - totalBags32kgSelect) > 0;
    } else {
      return (totalBags - this.bagStack?.length) > 0
    }
  }

  private addBagToPay(bagWeight: TypeBagsWeight, extraBags?: BagAncillarieInt) {
    const bag: BagPassangerInt = {
      idBag: getUniqueId(4),
      commercialName: extraBags?.commercialName || '',
      emdConsummedAtIssuance: '',
      legCode: '',
      quantity: 1,
      order: extraBags.order,
      used: false,
      groupCode: GROUP_CODE.BAGS,
      selected: true,
      type: extraBags?.type || '',
      rficSubcode: '',
      typeBagWeight: bagWeight,
      paid: false,
      statusBag: StatusBag.TO_PAY,
      currency: extraBags?.currency || undefined
    }
    this.bagStack.push(bag);
  }

  public getStatusBagColumn() {
    const bagsReeemedAplied = this.bagStack.find(x => x.statusBag == StatusBag.REDEEMED_APPLIED && !x.used && x.selected);
    const bagsToPay = this.bagStack.find(x => x.statusBag == StatusBag.TO_PAY && !x.used && x.selected);
    const bagsInclude = this.bagStack.find(x => x.statusBag == StatusBag.INCLUDE && !x.used && x.selected);
    const bagsPaid = this.bagStack.find(x => x.statusBag == StatusBag.PAID && !x.used && x.selected);
    if (bagsToPay) {
      return StatusBag.TO_PAY;
    } else if (bagsPaid) {
      return StatusBag.PAID;
    } else if (bagsReeemedAplied) {
      return StatusBag.REDEEMED_APPLIED;
    } else if (bagsInclude)
      return StatusBag.INCLUDE;
    else
      return StatusBag.NONE
  }

  public getStatusBagColumnPremier(isViewPremier: boolean = false) {
    const bagsReeemedAplied = this.bagStack.find(x => x.statusBag == StatusBag.REDEEMED_APPLIED && !x.used && x.selected);
    const bagsToPay = this.bagStack.find(x => x.statusBag == StatusBag.TO_PAY && !x.used && x.selected);
    let bagsInclude, bagsPaid;

    if (isViewPremier) {
      bagsInclude = this.bagStack.find(x => x.statusBag == StatusBag.INCLUDE && !x.used && x.selected && x.typeBagWeight != TypeBagsWeight._32KG);
      bagsPaid = this.bagStack.find(x => x.statusBag == StatusBag.PAID && !x.used && x.selected);
    } else {
      bagsInclude = this.bagStack.find(x => x.statusBag == StatusBag.INCLUDE && !x.used && x.selected);
      bagsPaid = this.bagStack.find(x => x.statusBag == StatusBag.PAID && !x.used && x.selected && x.typeBagWeight != TypeBagsWeight._25KG);
    }

    if (bagsToPay && isViewPremier) {
      return StatusBag.TO_PAY;
    } else if (bagsPaid) {
      return StatusBag.PAID;
    } else if (bagsReeemedAplied && isViewPremier) {
      return StatusBag.REDEEMED_APPLIED;
    } else if (bagsInclude)
      return StatusBag.INCLUDE;
    else
      return StatusBag.NONE
  }

  public get getTotalAmountBagColumn() {
    const bagsToPay = this.bagStack.find(x => x.statusBag == StatusBag.TO_PAY && !x.used && x.selected);
    let total = 0;

    if (bagsToPay) {
      this.bagStack.filter(x => x.statusBag == StatusBag.TO_PAY && !x.used && x.selected).map(x => total += x?.currency?.total)
    }

    return total;
  }

  public get getCurrencyCodeBagsToPay() {
    const bagsToPay = this.bagStack.find(x => x.statusBag == StatusBag.TO_PAY && !x.used && x.selected);
    let currencyCode = 'MXN';

    if (bagsToPay) {
      currencyCode = bagsToPay.currency?.currencyCode;
    }

    return currencyCode;
  }

  public get bagCarryon() {
    return this.bagStackCarryon[0];
  }

  public onPlusExtraWeightCarryon(add: boolean, extraBagsCarryon: BagAncillarieInt[]) {
    let bag = this.bagStackCarryon[0];
    const extraBags = extraBagsCarryon?.find(x => x.order == (this.bagStackCarryon.length))
    if (add) {
      bag.statusBag = StatusBag.TO_PAY;
      bag.commercialName = extraBags?.commercialName || '';
      bag.type = extraBags?.type || '';
      bag.currency = extraBags?.currency || undefined;
      bag.order = extraBags?.order;
    } else {
      if (bag.used) {
        bag.statusBag = StatusBag.DOCUMENT;
      } else {
        bag.statusBag = StatusBag.INCLUDE;
      }
    }
  }

  public get getStatusBagColumnCarryon() {
    const bagsToPay = this.bagStackCarryon.find(x => x.statusBag == StatusBag.TO_PAY);
    const bagsInclude = this.bagStackCarryon.find(x => x.statusBag == StatusBag.INCLUDE && !x.used);
    const bagsPaid = this.bagStackCarryon.find(x => x.statusBag == StatusBag.PAID && !x.used);
    const bagsDocument = this.bagStackCarryon.find(x => x.used);

    if (bagsToPay) {
      return StatusBag.TO_PAY;
    } else if (bagsPaid) {
      return StatusBag.PAID;
    } else if (bagsDocument) {
      return StatusBag.DOCUMENT;
    } else if (bagsInclude)
      return StatusBag.INCLUDE;
    else
      return StatusBag.NONE;
  }

  public get getTotalAmountBagColumnCarryon() {
    const bagsToPay = this.bagStackCarryon.find(x => x.statusBag == StatusBag.TO_PAY);
    let total = 0;
    if (bagsToPay) {
      this.bagStackCarryon.filter(x => x.statusBag == StatusBag.TO_PAY).map(x => total += x?.currency?.total)
    }
    return total;
  }

  public get getCurrencyCodeBagsToPayCarryon() {
    const bagsToPay = this.bagStackCarryon.find(x => x.statusBag == StatusBag.TO_PAY);
    let currencyCode = 'MXN';
    if (bagsToPay) {
      currencyCode = bagsToPay.currency?.currencyCode;
    }
    return currencyCode;
  }

  public getSeatBenifit(benefit: Benefit) {
    const benefitData: TierBenefit = benefit?._collection[0] ?? undefined

    if (benefitData?.seatBenefits) {
      this.seatBenefit = benefitData.seatBenefits;
      this.seatBenefit.label = "freeSeatUpgradeBenefit";
    } else {
      this.seatBenefit = null;
    }
  }

  public getSeatPassanger(segmentChoices: BookedSegmentChoiceCollection) {
    this.seats = [];
    this.apiSeats = [];
    this.apiSeatsPaids = [];

    segmentChoices?._collection.map(x => {
      const seat_ = x.seat;
      let seat: SeatPassanger = {};
      seat.segmentCode = x.segmentCode;
      if (seat_) {
        seat.code = seat_.code.charAt(0) == "0" ? seat_.code.substring(1, seat_.code.length) : seat_.code;
        seat.paidSeat = x.paidSeat;
        if (seat.paidSeat) {
          seat.status = SeatPassangerEstatus.PAID;
        } else {
          seat.status = SeatPassangerEstatus.ASSIGNED;
        }

        if (seat.paidSeat) {
          this.apiSeatsPaids.push(seat);
        }
      }
      else {
        seat.code = "not assigned"
        seat.status = SeatPassangerEstatus.NO_ASSIGNED;
        seat.paymentDue = false;
      }
      this.seats.push(seat);
    });
    this.apiSeats = [];

    for (var seatIndex = 0; seatIndex < this.seats.length; seatIndex++) {
      var seat = this.seats[seatIndex];
      this.apiSeats.push({ "code": seat.code });
    }
  }

  public getStatusSeatPreview() {
    const seatsPending = this.seats.find(x => x.status == SeatPassangerEstatus.PENDING_PAYMENT);
    const seatsPaid = this.seats.find(x => x.status == SeatPassangerEstatus.PAID);
    const seatsAssigned = this.seats.find(x => x.status == SeatPassangerEstatus.ASSIGNED);

    if (seatsPending) {
      return SeatPassangerEstatus.PENDING_PAYMENT;
    }
    if (seatsPaid) {
      return SeatPassangerEstatus.PAID;
    }
    if (seatsAssigned) {
      return SeatPassangerEstatus.ASSIGNED;
    } else {
      return SeatPassangerEstatus.NO_ASSIGNED;
    }
  }

  public getBookingClasse(bookingClasses: BookingClasses) {
    if (bookingClasses?._collection?.length > 0) {
      this.cabinClass = bookingClasses._collection[0].bookingCabin == 'Y' ? 'Normal' : 'Priority';
    } else {
      this.cabinClass = 'Normal';
    }
  }

  public bags(passengerInfo: any) {
    const freeBaggageAllowancePerLegsArray = passengerInfo.freeBaggageAllowancePerLegsArray;

    if (freeBaggageAllowancePerLegsArray?.length > 0) {
      const freeBaggageAllowance = freeBaggageAllowancePerLegsArray[0].freeBaggageAllowance;
      this.freeCheckedBagAllowance = freeBaggageAllowance.checked;
      this.freeCarryOnBagAllowance = freeBaggageAllowance.carryOn;
      this.freeCarryOnBagAllowanceUnits = {
        kg: freeBaggageAllowance.carryOnWeightKG,
        lb: freeBaggageAllowance.carryOnWeightLB,
      };
      const checkedWeightCollection = freeBaggageAllowance?.checkedWeightCollection;
      if (checkedWeightCollection?.length > 1) {
        if (checkedWeightCollection[0].checkedWeightUnit === 'LB') {
          this.freeCheckedBagAllowanceMaxWeight = checkedWeightCollection[1].checkedFreeWeight;
          this.freeCheckedBagAllowanceWeightUnit = checkedWeightCollection[1].checkedWeightUnit;

          this.freeCheckedBagAllowanceLabel =
            checkedWeightCollection[1].checkedFreeWeight + " " + checkedWeightCollection[1].checkedWeightUnit + "/" +
            checkedWeightCollection[0].checkedFreeWeight + " " + checkedWeightCollection[0].checkedWeightUnit;
        } else {
          this.freeCheckedBagAllowanceMaxWeight = checkedWeightCollection[0].checkedFreeWeight;
          this.freeCheckedBagAllowanceWeightUnit = checkedWeightCollection[0].checkedWeightUnit;

          if (freeBaggageAllowancePerLegsArray.length >= 1 && freeBaggageAllowance && checkedWeightCollection.length >= 2) {
            this.freeCheckedBagAllowanceLabel =
              checkedWeightCollection[0].checkedFreeWeight + " " + checkedWeightCollection[0].checkedWeightUnit + "/" +
              checkedWeightCollection[1].checkedFreeWeight + " " + checkedWeightCollection[1].checkedWeightUnit;
          } else if (freeBaggageAllowancePerLegsArray.length >= 1 && freeBaggageAllowance && checkedWeightCollection.length >= 1) {
            this.freeCheckedBagAllowanceLabel =
              checkedWeightCollection[0].checkedFreeWeight + " " + checkedWeightCollection[0].checkedWeightUnit;
          }
        }

        var checkedFreeOverWeight = checkedWeightCollection[1].checkedFreeOverWeight;
        if (checkedFreeOverWeight !== 0) {
          this.freeCheckedBagAllowenceExtraWeight = {
            lb: checkedWeightCollection[0].checkedFreeOverWeight,
            kg: checkedFreeOverWeight
          };
        }
      }


    } else if (passengerInfo.freeBaggageAllowance) {
      this.freeCheckedBagAllowance = passengerInfo.freeBaggageAllowance.checked;
      this.freeCarryOnBagAllowance = passengerInfo.freeBaggageAllowance.carryOn;

      this.freeCheckedBagAllowanceMaxWeight = passengerInfo.freeBaggageAllowance.checkedMaxWeight;
      this.freeCheckedBagAllowanceWeightUnit = passengerInfo.freeBaggageAllowance.checkedWeightUnit;

      this.freeCheckedBagAllowanceLabel = this.freeCheckedBagAllowanceMaxWeight + "/" + this.freeCheckedBagAllowanceWeightUnit;

      this.freeCarryOnBagAllowanceUnits = {
        kg: passengerInfo.freeBaggageAllowance.carryOnWeightKG,
        lb: passengerInfo.freeBaggageAllowance.carryOnWeightLB,
      };
    } else {
      this.freeCheckedBagAllowance = 0;
    }
    this.isCarryOnDroppedOff = passengerInfo.carryOnChecked;
    this.carryOnChecked = passengerInfo.carryOnChecked ? 1 : 0;

    this.loyalty = passengerInfo.loyalty?.length > 0 ? passengerInfo.loyalty[0] : passengerInfo.loyalty;


    this.bagsMaxAllowableWeight = 45;
    this.bagsOverweightUnitCharge = 99.0;

    this.numPaidBags = 0;

    this.numRedeemedBags = 0;
    this.numRedeemedUsedBags = 0;
    this.numRedeemedAndUsedBags = 0;

    this.numPaidCarryOnBags = 0;
    this.numPaidBags20K = 0;

    if (passengerInfo.ancillaries && passengerInfo.ancillaries._collection &&
      passengerInfo.ancillaries._collection.length) {
      for (var index = 0; index < passengerInfo.ancillaries._collection.length; index++) {
        var ancillary = passengerInfo.ancillaries._collection[index];

        if (passengerInfo.legCode === ancillary.legCode) {
          try {
            if (ancillary.rficSubcode === '07X' && ancillary.groupCode === "TS") {
              this.numPaidCarryOnBags = 1;
              this.freeCarryOnBagAllowanceUnits = {
                kg: 15,
                lb: 33
              };
              continue;
            }
          }
          catch (e) {
          }
          if (ancillary.groupCode && ancillary.groupCode === 'BG') {
            if (ancillary.redeemed) {
              this.numRedeemedAndUsedBags++;
              if (ancillary.used) {
                this.numRedeemedUsedBags++;
              } else {
                this.numRedeemedBags++;
              }
              continue;
            }
            const bag20kg = BagsWeightCode["20KG"].includes(ancillary.rficSubcode);
            if (bag20kg) {
              this.numPaidBags20K++;
            }
            else {
              this.numPaidBags++;
            }
          }
        }
      }
    }
    this.numCheckedInBags = 0;
    this.numCheckedInBags20 = 0;
    this.numCarryOnBags = 0;
    this.totalDue = 0;
    this.numBagsDroppedOff = 0;
    if (passengerInfo.checkedBags) {
      this.numBagsDroppedOff = passengerInfo.checkedBags;
    }

    this.numBagsDroppedOff20KG = 0;
    if (passengerInfo.checkedBags20KG) {
      this.numBagsDroppedOff20KG = passengerInfo.checkedBags20KG;
    }
    this.numCheckedInBagsPremier = 0;

    this.paidAncillaries = this.ancillaries._collection.map(function (bag) {
      bag.weight = ''
      return bag;
    });

  }

  public get benefitCode(): string {
    let code = null
    const benefit = this.benefit as BenefitInt;
    const [element] = benefit?._collection;
    if (element) {
      const { bagBenefitCobrand, bagBenefit } = element;
      if (bagBenefitCobrand) {
        code = bagBenefitCobrand.freeBagAllowanceByCardList[0].cobrandCode;
      }
      else {
        code = bagBenefit.reason
      }

    }
    return code;
  }

}
